module.exports = __webpack_public_path__ + "img/translation.621ea674.png";